import axiosInstance from "../axiosInstance";

export const POSTCheckVersion = async (clientVersion) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_WMS_BASE_URL}/permisos/version-check`,
      { version: clientVersion },
      { headers: { "Content-Type": "application/json" } },
    );
    return { success: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      success: false,
      status: error.response?.status,
      data: error.response?.data,
      message: error.response?.data?.message || "Error al verificar versión",
    };
  }
};
